import { DcSccBaseHandlerV1 } from 'dc-scc';

export abstract class Base extends DcSccBaseHandlerV1
{
	protected _service=null;
	
	public setService(service)
	{
		this._service	= service;
		return this;
	}
	public getService()
	{
		return this._service;
	}
	public getAuto()
	{
		return this.getService().getAuto();
	}
}